// imports section Start
import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import CnExNote from "../../components/bill/return/CnExNote";
import { decodeUrl } from "../../utils/common/UrlUtils";
// imports section End

/**
 * ReturnNotePrint — standalone print page for credit / exchange notes.
 *
 * URL params:
 *   data — base64-encoded JSON of the noteData object
 *   actionText — "Return" | "Exchange"
 *   storeName  — restaurant name
 *   address    — store address
 */
function ReturnNotePrint() {
  const queryParams = new URLSearchParams(window.location.search);

  // Decode params
  const rawData = queryParams.get("data");
  const actionText = queryParams.get("actionText") || "Return";
  const storeName = queryParams.get("storeName") || "";
  const address = queryParams.get("address") || "";

  let noteData = null;
  try {
    noteData = rawData ? JSON.parse(decodeUrl(rawData)) : null;
  } catch (e) {
    console.error("Failed to parse note data:", e);
  }

  // Auto-print after render
  useEffect(() => {
    if (noteData) {
      const timer = setTimeout(() => {
        window.print();
      }, 400);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        p: 2,
        "@media print": {
          p: 0,
          m: 0,
        },
      }}
    >
      <Box
        sx={{
          width: 280,
          "@media print": {
            width: "100%",
          },
        }}
      >
        <CnExNote
          noteData={noteData}
          actionText={actionText}
          storeName={storeName}
          address={address}
          isPrint
        />
      </Box>
    </Box>
  );
}

export default ReturnNotePrint;
